import React from 'react';
import { motion } from 'framer-motion';
import { Newspaper, ExternalLink, Clock } from 'lucide-react';
import { useNews } from '../hooks/useNews';

const NewsFeed: React.FC = () => {
  const { articles, loading } = useNews();

  if (loading) {
    return (
      <div className="bg-gray-900/50 backdrop-blur-xl border border-cyan-500/30 rounded-xl p-4">
        <div className="animate-pulse flex items-center gap-2">
          <Newspaper className="text-cyan-500" />
          <span className="text-gray-400">Loading news...</span>
        </div>
      </div>
    );
  }

  return (
    <div className="bg-gray-900/50 backdrop-blur-xl border border-cyan-500/30 rounded-xl p-4">
      <div className="flex items-center gap-2 mb-3">
        <Newspaper className="text-cyan-500" />
        <h3 className="font-bold">Disaster News</h3>
      </div>

      <div className="space-y-3 max-h-60 overflow-y-auto">
        {articles.map((article, index) => (
          <motion.a
            key={article.id}
            href={article.url}
            target="_blank"
            rel="noopener noreferrer"
            initial={{ opacity: 0, x: -20 }}
            animate={{ opacity: 1, x: 0 }}
            transition={{ delay: index * 0.1 }}
            className="block p-2 bg-black/30 rounded-lg hover:bg-black/50 transition-all"
          >
            <div className="flex justify-between items-start">
              <div className="flex-1">
                <p className="text-sm font-medium line-clamp-2">{article.title}</p>
                <div className="flex items-center gap-2 mt-1 text-xs text-gray-400">
                  <span>{article.source}</span>
                  <Clock size={10} />
                  <span>{new Date(article.publishedAt).toLocaleTimeString()}</span>
                </div>
              </div>
              <ExternalLink size={12} className="text-gray-400 ml-2" />
            </div>
          </motion.a>
        ))}
      </div>
    </div>
  );
};

export default NewsFeed;